import { useEffect, useRef } from 'react';
import { sendDrinkSteps } from '@/mocks/homeData';

export default function SendDrinkSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.send-animate').forEach((child, i) => {
              (child as HTMLElement).style.animationDelay = `${i * 0.12}s`;
              child.classList.add('animate-fade-in-up');
            });
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative w-full py-24 md:py-32 bg-background-950">
      {/* Yellow accent line top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500/30 to-transparent" />

      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="send-animate opacity-0 text-primary-500 text-xs font-bold tracking-[0.3em] uppercase mb-4">
            The Moment
          </p>
          <h2 className="send-animate opacity-0 text-3xl sm:text-4xl md:text-5xl font-black text-foreground-50 tracking-tight leading-tight">
            Send something<br />
            <span className="text-primary-500">better than a text.</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto mb-16">
          {sendDrinkSteps.map((s) => (
            <div
              key={s.num}
              className="send-animate opacity-0 group p-6 rounded-2xl bg-background-100 border border-background-200/30 hover:border-primary-500/40 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-500/20 flex items-center justify-center mb-4 group-hover:bg-primary-500/30 transition-colors">
                <i className={`${s.icon} text-primary-500 text-xl`} />
              </div>
              <span className="text-primary-500 text-xs font-bold tracking-wider uppercase block mb-2">
                Step {s.num}
              </span>
              <p className="text-foreground-50 text-sm font-semibold">{s.label}</p>
            </div>
          ))}
        </div>

        {/* Recipient notification */}
        <div className="send-animate opacity-0 max-w-md mx-auto">
          <div className="bg-background-100 border border-background-200/40 rounded-2xl p-5 flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-primary-500/20 flex items-center justify-center shrink-0">
              <i className="ri-goblet-fill text-primary-500 text-lg" />
            </div>
            <div className="flex-1">
              <p className="text-foreground-50 text-sm font-semibold">Alex sent you a drink</p>
              <p className="text-foreground-500 text-xs">Redeem at The Franklin tonight</p>
            </div>
            <span className="text-primary-500 text-xs font-bold bg-primary-500/20 px-3 py-1.5 rounded-full">
              NEW
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}